import React from 'react';
import styled from 'styled-components';

const ToggleButton = styled.button`
  width: var(--icon-button-size);
  height: var(--icon-button-size);

  outline: none;
  margin: 0;
  padding: 0;
  overflow: visible;

  background: transparent;
  color: inherit;
  cursor: pointer;

  font: inherit;
  line-height: 0;

  border-radius: var(--spacer-small);

  -webkit-font-smoothing: inherit;
  -moz-osx-font-smoothing: inherit;
  -webkit-appearance: none;

  background-color: rgb(var(--bg-primary), 0);
  border-radius: var(--border-radius);
  border: var(--glass-border);
  cursor: pointer;

  backdrop-filter: var(--glass-filter);

  box-shadow: 0 0 32px 0 rgba(255, 255, 255, 0);

  transition:
      background-color 250ms ease-in-out,
      box-shadow 250ms ease-in-out;

  &:hover {
      background-color: var(--glass-bg-hover);
      box-shadow: var(--glass-glow-hover);
  }

  svg {
    width: 2rem;
    height: auto;
  }
`;

export default function HeaderToggle({ className, isOpen, onClick }) {
  return (
    <ToggleButton className={className} aria-label="menu-switch" type="button" onClick={onClick}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        {isOpen ? (
          <>
            <path
              fill="rgb(var(--text-tertiary))"
              d="M150 96l267 267-54 53L97 149z"
            />
            <path
              fill="rgb(var(--text-tertiary))"
              d="M363 95L96 362l53 53 267-266z"
            />
          </>
        ) : (
          <>
            <path fill="rgb(var(--text-tertiary))" d="M96 352h320v64H96z" />
            <path fill="rgb(var(--text-tertiary))" d="M96 96h320v64H96z" />
            <path fill="rgb(var(--text-tertiary))" d="M96 224h320v64H96z" />
          </>
        )}
      </svg>
    </ToggleButton>
  );
}
